import React,{useState,useEffect} from 'react'
import Select from 'react-select';
import { GrSubtractCircle } from "react-icons/gr";
import { FiPlusCircle } from "react-icons/fi";
import { useDispatch } from "react-redux";
import {getQuery,createReportAndReportColumn,getReportAndReportColumn,updateReportAndReportColumnById} from "./../../../../../services/global_redux/globale_actions/CreateReport.action"
import { getAllUnits } from "./../../../../../services/global_redux/globale_actions/Unit.action"
function CreateReport({showSnackbar,setLoading}) {
    const [filterType, setFilterType] = useState("New");
    const [query, setQuery] = useState('');
    const [queryError, setQueryError] = useState('');
    const [queryHeaders, setQueryHeaders] = useState(null);
    const [disableRun, setDisableRun] = useState(false);
    const [headerId, setHeaderId] = useState(null);
    const [headerName, setHeaderName] = useState(null);
    const [createdHeaders,setCreatedHeaders] = useState(null)
    const [getHeadersData, setGetHeadersData] = useState(null);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [headerQueryCustomization, setHeaderQueryCustomization] = useState(null);
    const [ClientId, setClientId] = useState(null);
    const [headerClientId, setHeaderClientId] = useState([]);
    // const [queryHeaders, setQueryHeaders] = useState(null);
    const dispatch = useDispatch();

    const getQueryData = async (e) => {
        e.preventDefault();
        const sendQuery = {
            query:query
        }
        try {
            const response = await dispatch(getQuery(sendQuery));
            if (response.success === true) {
                setQueryError(null);
                const rawHeaders = response.data.data.columns;
                const formatted = rawHeaders.map(col => ({
                    actualColumn: col,
                    displayHeader: "",
                    isRowEnabled: "",
                    isFilterChecked: false,
                    dropdownValue: ""
                }));
                setQueryHeaders(formatted);
                setQueryError(null)
                setDisableRun(true)
            }else{
                setQueryError(response.message.error);
                setQueryHeaders(null)
                setDisableRun(false)

            }
        } catch (err) {
        console.error("Failed to fetch states:", err);

        setQueryError(err.message.error);
        setQueryHeaders(null)
        setDisableRun(false)
        }
    };
    const handleFilterCheckToggle = (index) => {
        const updated = [...queryHeaders];
        const current = updated[index];

        if (!current.isFilterChecked && updated.filter(r => r.isFilterChecked).length >= 5) return;

        current.isFilterChecked = !current.isFilterChecked;
        setQueryHeaders(updated);
    };
    const handleDropdownChange = (index, value) => {
        const updated = [...queryHeaders];
        updated[index].dropdownValue = value;
        setQueryHeaders(updated);
    };
    const handleHeaderChange = (index, value) => {
        const updated = [...queryHeaders];
        updated[index].displayHeader = value;
        setQueryHeaders(updated);
    };
    const handleSubmit = async (e)  => {
        alert(headerClientId);
        const filtereisRowEnableddRows = queryHeaders.filter(row => row.isRowEnabled);
        const actualColumns = filtereisRowEnableddRows.map(r => r.actualColumn);
        const displayName = filtereisRowEnableddRows.map(r => r.displayHeader);
        const filtersWithTypes = filtereisRowEnableddRows
            .filter(row => row.dropdownValue)
            .map(row => ({
                column: row.actualColumn,
                type: row.dropdownValue
            }));
            const errors = queryHeaders.filter((row) => {
                if (row.actualColumn === "id") {
                  row.displayHeader = "id";
                }

                return row.isRowEnabled && !row.displayHeader.trim();
              });
            if (errors.length > 0) {
                alert(errors);
                console.log('errors',errors);
                return;
              }
              const dataSend = {
                    "report_code":headerId,
                    "report_name":headerName,
                    "sql_query":query,
                    "display_column":displayName,
                    "column_code":actualColumns,
                    "filter_column":filtersWithTypes,
                    "filter_column_type":'noData',
                    "client_id":headerClientId?.map(opt => opt.value),
                    "query_customization":headerQueryCustomization
                }
              if(filterType == 'New'){
                try{
                    const responseDatas = await dispatch(createReportAndReportColumn(dataSend));
                    if (responseDatas.success === true) {
                        showSnackbar(responseDatas.message.data.message, 'success')
                        setQueryError(null);
                        setQueryHeaders(null);
                        setDisableRun(false);
                        setQuery('');
                        setHeaderId(null);
                        setHeaderName('');
                        setHeaderClientId();
                        setHeaderQueryCustomization();
                        setFilterType("New")
                    }else{
                        showSnackbar('An error occurred', 'error');
                    }

                } catch (err) {
                    console.error("Failed to fetch states:", err);
                    showSnackbar('An error occurred', 'error');

                    }
              }else{
                try{
                    const responseDatas = await dispatch(updateReportAndReportColumnById(headerId,dataSend));
                    if (responseDatas.success === true) {
                        showSnackbar(responseDatas.message.data.message, 'success')
                        setQueryError(null);
                        setQueryHeaders(null);
                        setDisableRun(false);
                        setQuery('');
                        setHeaderId(null);
                        setHeaderName('');
                        setHeaderClientId();
                        setHeaderQueryCustomization();
                        setFilterType("New")
                    }else{
                        showSnackbar('An error occurred', 'error');
                    }

                } catch (err) {
                    console.error("Failed to fetch states:", err);
                    showSnackbar('An error occurred', 'error');

                    }
              }
    };
    const handleChangeQuery = async (e)  => {
                setQueryError(null);
                setQueryHeaders(null)
                setDisableRun(false)
                setHeaderName(null)
                setHeaderClientId(null);
                setHeaderQueryCustomization(null);
    }
    const handleRowEnableToggle = (index) => {
        const updated = [...queryHeaders];
        const current = updated[index];
        current.isRowEnabled = !current.isRowEnabled;

        if (!current.isRowEnabled) {
        current.isFilterChecked = false;
        current.dropdownValue = '';
        }

        setQueryHeaders(updated);
    };
    const FilterTypecheck = (type)=>{
        setFilterType(type)
        setHeaderId(null)
        setHeaderName(null)
        setHeaderClientId(null);
        setHeaderQueryCustomization(null);
    }
    const getCreatedReportData = async (e) => {
        try {
            const reportResponse = await dispatch(getReportAndReportColumn());
                if (reportResponse.success === true) {
                    setGetHeadersData(reportResponse.data);
                    setCreatedHeaders(reportResponse.data.map(item => item.report_code))
                }
            } catch (err) {
            console.error("Failed to fetch states:", err);

            setQueryError(err.message.error);
            setQueryHeaders(null)
            setDisableRun(false)
            }
    }
    useEffect(() => {
        getCreatedReportData();
    }, []);
    // const setHeaderIdforExist =async (data)=>{
    //     const selectedColumns = getHeadersData.filter(item => item.report_code == data);

    //     if(selectedColumns){

    //         setHeaderName(selectedColumns[0].report_name)
    //         setQuery(selectedColumns[0].sql_query)
    //         setHeaderId(data);
    //         const sendQuery = {
    //             query:selectedColumns[0].sql_query
    //         }
    //         try {
    //             const response = await dispatch(getQuery(sendQuery));
    //             if (response.success === true) {
    //                 setQueryError(null);
    //                 const rawHeaders = response.data.data.columns;
    //                 console.log("headers",rawHeaders);
    //                 console.log("selectedDate",selectedColumns);
    //                 const formatted = rawHeaders.map(col => ({
    //                     actualColumn: col,
    //                     displayHeader: "",
    //                     isRowEnabled: "",
    //                     isFilterChecked: false,
    //                     dropdownValue: ""
    //                 }));
    //                 setQueryHeaders(formatted);
    //                 setQueryError(null)
    //                 setDisableRun(true)
    //             }else{
    //                 setQueryError(response.message.error);
    //                 setQueryHeaders(null)
    //                 setDisableRun(false)

    //             }
    //         } catch (err) {
    //         console.error("Failed to fetch states:", err);

    //         setQueryError(err.message.error);
    //         setQueryHeaders(null)
    //         setDisableRun(false)
    //         }
    //     }

    // }
    const setHeaderIdforExist = async (data) => {
        const selectedColumns = getHeadersData.filter(item => item.report_code === data);

        if (selectedColumns.length > 0) {
            const selected = selectedColumns[0];

            setHeaderName(selected.report_name);
            setQuery(selected.sql_query);
            setHeaderId(data);
            // setHeaderClientId(selected.client_id);
            setHeaderQueryCustomization(selected.query_customization);

            const sendQuery = {
                query: selected.sql_query
            };

            try {
                const response = await dispatch(getQuery(sendQuery));

                if (response.success === true) {
                    setQueryError(null);

                    const rawHeaders = response.data.data.columns;
                    const colNames = selected.column_code?.split(',') || [];
                    const displayNames = selected.display_column?.split(',') || [];
                    let filterColumns = [];

                    try {
                        filterColumns = selected.filter_column ? JSON.parse(selected.filter_column) : [];
                    } catch (err) {
                        console.warn("Invalid JSON in filter_column:", err);
                    }

                    const existingSelections = colNames.map((col, idx) => {
                        const filter = filterColumns.find(f => f.column === col);
                        return {
                            actualColumn: col,
                            displayHeader: displayNames[idx] || "",
                            isRowEnabled: true,
                            isFilterChecked: !!filter,
                            dropdownValue: filter?.type || ""
                        };
                    });

                    const formatted = rawHeaders.map(col => {
                        const existing = existingSelections.find(item => item.actualColumn === col);
                        return {
                            actualColumn: col,
                            displayHeader: existing?.displayHeader || "",
                            isRowEnabled: existing ? true : false,
                            isFilterChecked: existing?.isFilterChecked || false,
                            dropdownValue: existing?.dropdownValue || ""
                        };
                    });

                    setQueryHeaders(formatted);
                    setDisableRun(true);
                } else {
                    setQueryError(response.message.error);
                    setQueryHeaders(null);
                    setDisableRun(false);
                }
            } catch (err) {
                console.error("Failed to fetch headers:", err);
                setQueryError(err.message?.error || "Unknown error");
                setQueryHeaders(null);
                setDisableRun(false);
            }
        }
    };
    const handleFetchClientAndUnit = async () => {
        try {
          const response = await dispatch(getAllUnits());
          if(response.success == true){
            setClientId(response.data.client_and_unit);
          }
        console.log(response.data.client_and_unit);
        } catch (err) {
          console.error("Failed to fetch states:", err);
        }
      };

      useEffect(() => {
        handleFetchClientAndUnit();
      }, [dispatch]);
      const clientOptions = Array.isArray(ClientId)
        ? ClientId.map(item => ({
            value: item.client_id,
            label: `${item.client_id}`
            }))
        : [];
        // const handleSelectChange = (selectedOptions) => {
        //     const isSelectingAll = selectedOptions?.some(opt => opt.value === '*');

        //     if (isSelectingAll) {
        //       setIsAllSelected(true);
        //       // store all real client_ids (not selectAll)
        //       const allIds = clientOptions.map(opt => opt.value);
        //       setHeaderClientId(allIds);
        //     } else {
        //       setIsAllSelected(false);
        //       // store only selected client_ids
        //       const ids = selectedOptions?.map(opt => opt.value) || [];
        //       setHeaderClientId(ids);
        //     }
        //   };
        const handleSelectChange = (selectedOptions) => {
            const isSelectingAll = selectedOptions?.some(opt => opt.value === 'All');

            if (isSelectingAll) {
              setIsAllSelected(true);
              setHeaderClientId([selectAllOption]); // Show only "All"
            } else {
              setIsAllSelected(false);
              setHeaderClientId(selectedOptions || []);
            }
          };



      const selectAllOption = {
        value: 'All',
        label: 'Select All'
      };

      const mergedOptions = isAllSelected
  ? [selectAllOption]
  : [selectAllOption, ...clientOptions];
  return (
    <div  className="container-fluid windown-min-height" >
        <div className="col-md-12 py-3">
            <div className="card m-3 shadow">
                <div className="card-header card-header-color py-2 bg-light">
                <div className="row align-items-center">
                    <div className="col-md-6">
                    <h6 className="text-dark mb-0"> Create Reports</h6>
                    </div>
                    <div className="col-md-6 text-end">
                    <a href="/dashboard" className="text-dark">
                        <i className="bi bi-x fs-4 cancel-icon"></i>
                    </a>
                    </div>
                </div>
                </div>

                <div className="card-body">
                    <div className="col-md-12">
                            <fieldset className="border p-3 rounded">
                                <div className="card-body">
                                    <div className="col-md-12 mb-3">
                                        <label>Report Type:</label>
                                        <div>
                                        <button
                                            className={`btn btn-sm me-2 ${filterType === "New" ? "btn-primary" : "btn-outline-primary"}`}
                                            onClick={() => FilterTypecheck("New")}
                                            disabled={disableRun}
                                        >
                                            New Report
                                        </button>
                                        <button
                                            className={`btn btn-sm ${filterType === "Existing" ? "btn-primary" : "btn-outline-primary"}`}
                                            onClick={() => FilterTypecheck("Existing")}
                                            disabled={disableRun}
                                        >
                                        Existing Report
                                        </button>
                                        </div>
                                    </div>
                                    <form onSubmit={getQueryData}>
                                        <div className="col-md-12">
                                            {filterType === "New" && (
                                                <div className="row">
                                                    <div className="col-md-3 mb-3">
                                                        <label htmlFor="reportId">Report ID <span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control" id="reportId" onChange={(e) => setHeaderId(e.target.value)} required />
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <label htmlFor="reportName">Report Name <span className="text-danger">*</span></label>
                                                        <input type="text" value={headerName} className="form-control" id="reportName" onChange={(e) => setHeaderName(e.target.value)} disabled={disableRun} required />
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <label htmlFor="QueryCustomization">Query Customization <span className="text-danger">*</span></label>
                                                        <select id="QueryCustomization" class="form-control text-center" value={headerQueryCustomization} onChange={(e) => setHeaderQueryCustomization(e.target.value)} disabled={disableRun} required >
                                                            <option value="">--Select--</option>
                                                            <option value="1">No</option>
                                                            <option  value="2">Yes</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <label htmlFor="ClientId">Client Id's </label>
                                                        <Select
                                                            isMulti
                                                            options={mergedOptions}
                                                            value={headerClientId}
                                                            onChange={handleSelectChange}
                                                            isDisabled={disableRun}
                                                            placeholder="--Select Client Ids--"
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            styles={{
                                                                control: (provided) => ({
                                                                  ...provided,
                                                                  maxHeight: '100px',
                                                                  overflowY: 'auto',
                                                                  flexWrap: 'wrap',
                                                                }),
                                                                valueContainer: (provided) => ({
                                                                  ...provided,
                                                                  maxHeight: '90px',
                                                                  overflowY: 'auto',
                                                                }),
                                                                menuList: (provided) => ({
                                                                  ...provided,
                                                                  maxHeight: '200px',
                                                                  overflowY: 'auto',
                                                                }),
                                                              }}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {filterType === "Existing" && (
                                                <div className="row">
                                                    <div className="col-md-3 mb-3">
                                                        <label htmlFor="reportIds">Report ID <span className="text-danger">*</span></label>
                                                        <select id="reportIds" class="form-control text-center" value={headerId} onChange={(e) => setHeaderIdforExist(e.target.value)} disabled={disableRun} required >
                                                            <option selected value="">--Select ID--</option>
                                                            {createdHeaders && createdHeaders.map((item,index)=>(
                                                                <option value={item}>{item}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <label htmlFor="reportName">Report Name <span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control" id="reportName" value={headerName} onChange={(e) => setHeaderName(e.target.value)} required />
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <label htmlFor="QueryCustomization">Query Customization  <span className="text-danger">*</span></label>
                                                        <select id="QueryCustomization" class="form-control text-center" value={headerQueryCustomization} onChange={(e) => setHeaderQueryCustomization(e.target.value)} disabled={disableRun} required >
                                                            <option value="null">--Select--</option>
                                                            <option value="1">No</option>
                                                            <option  value="2">Yes</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <label htmlFor="ClientId">Client Id's</label>
                                                        <Select
                                                            isMulti
                                                            options={mergedOptions}
                                                            value={headerClientId}
                                                            onChange={handleSelectChange}
                                                            isDisabled={disableRun}
                                                            placeholder="--Select Client Ids--"
                                                            className="basic-multi-select"
                                                            classNamePrefix="select"
                                                            styles={{
                                                                control: (provided) => ({
                                                                  ...provided,
                                                                  maxHeight: '100px',
                                                                  overflowY: 'auto',
                                                                  flexWrap: 'wrap',
                                                                }),
                                                                valueContainer: (provided) => ({
                                                                  ...provided,
                                                                  maxHeight: '90px',
                                                                  overflowY: 'auto',
                                                                }),
                                                                menuList: (provided) => ({
                                                                  ...provided,
                                                                  maxHeight: '200px',
                                                                  overflowY: 'auto',
                                                                }),
                                                              }}
                                                        />

                                                    </div>

                                                </div>
                                            )}
                                            <textarea
                                            className="form-control bg-light"
                                            style={{
                                                width: '100%',
                                                height: '200px',
                                                border: '1px solid #ccc',
                                                padding: '15px',
                                                fontFamily: 'monospace',
                                                fontSize: '14px',
                                                resize: 'vertical',
                                                outline: 'none',
                                                boxSizing: 'border-box',
                                            }}
                                            disabled={disableRun}
                                            value={query}
                                            onChange={(e) => setQuery(e.target.value)}
                                            placeholder="Write your SQL query"
                                            ></textarea>
                                            <span className='text-danger mt-3' style={{ fontSize:'10px' }}><b>Note: Query must start with "select"</b> </span>
                                            <div className="col-md-12">
                                                {queryError && (
                                                    <span className=' text-danger'>Error : {queryError}</span>
                                                )}
                                            </div>
                                            <button className="btn btn-success btn-sm float-end mt-3" disabled={disableRun}>Run</button>
                                        </div>
                                    </form>
                                </div>
                            </fieldset>

                        {queryHeaders && (
                            <fieldset className="border p-3 rounded mt-3">
                                <div className="table-responsive bg-white border-1 mx-3 mb-4 tablefontsize">
                                <table className="table client-table table-bordered">
                                    <thead className='sticky-top sticky-col-form'>
                                    <tr>
                                        <th><input type="checkbox" disabled /></th>
                                        <th>Actual Column</th>
                                        <th>Display Column</th>
                                        <th>Filter</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {queryHeaders
                                    .map((row, index) => (
                                        <tr key={index}>
                                        <td>
                                          <input
                                            type="checkbox"
                                            checked={row.isRowEnabled || row.actualColumn == "id"}
                                            onChange={() => handleRowEnableToggle(index)}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={row.actualColumn}
                                            className="form-control form-control-sm"
                                            disabled
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            value={row.actualColumn === "id" ? "id" : row.displayHeader}
                                            disabled={!row.isRowEnabled}
                                            onChange={(e) => handleHeaderChange(index, e.target.value)}
                                          />
                                        </td>
                                        <td>
                                          <div className="d-flex align-items-center gap-2">
                                            {/* Filter checkbox - max 5 */}
                                            <input
                                              type="checkbox"
                                              checked={row.isFilterChecked}
                                              value={row.actualColumn}
                                              disabled={
                                                !row.isRowEnabled ||
                                                (!row.isFilterChecked &&
                                                  queryHeaders.filter(r => r.isFilterChecked).length >= 5)
                                              }
                                              onChange={() => handleFilterCheckToggle(index)}
                                            />
                                            <select
                                              className="form-control form-control-sm"
                                              disabled={!row.isRowEnabled || !row.isFilterChecked}
                                              value={row.dropdownValue}
                                              onChange={(e) => handleDropdownChange(index, e.target.value)}
                                            >
                                              <option value="">Data Type</option>
                                              <option value="number">Number</option>
                                              <option value="text">Text</option>
                                              <option value="dropdown">Select Dropdown</option>
                                            </select>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                    </tbody>
                                </table>
                                </div>

                                <button className="btn btn-sm btn-success float-end m-2" onClick={handleSubmit}>
                                Submit
                                </button>
                                <button className="btn btn-sm btn-primary float-end m-2" onClick={handleChangeQuery}>Change query</button>
                            </fieldset>
                        )}


                    </div>
                </div>
            </div>
        </div>
    </div>

  )
}

export default CreateReport
